import { Map, List } from 'immutable';

import { TYPES } from './actions';
import Logger from '../../../lib/Logger';

export default function CognitoFormsAdmin(
  state = Map({
    isLoading: false,
    pages: {},
    isFormVisible: false,
  }),
  action
) {
  Logger.log(
    'debug',
    `[state.CognitoFormsAdmin.reducers] CognitoFormsAdmin(%j, %j)`,
    state,
    action
  );

  switch (action.type) {
    case TYPES.COGNITO_FORM_ADMIN_LIST_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.COGNITO_FORM_ADMIN_LIST_SUCCESS:
      return state
        .mergeDeep({
          isLoading: false,
          pages: {
            [action.order]: {
              [action.limit]: {
                [action.page]: null,
              },
            },
          },
          total: action.total,
          lastUpdated: action.receivedAt,
        })
        .setIn(
          ['pages', action.order, action.limit, action.page],
          List(action.result)
        );

    case TYPES.COGNITO_FORM_ADMIN_LIST_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.COGNITO_FORM_ADMIN_READ_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.COGNITO_FORM_ADMIN_READ_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.COGNITO_FORM_ADMIN_READ_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.COGNITO_FORM_ADMIN_UPDATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.COGNITO_FORM_ADMIN_UPDATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.COGNITO_FORM_ADMIN_UPDATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.COGNITO_FORM_ADMIN_CREATE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.COGNITO_FORM_ADMIN_CREATE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          created_id: action.id,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.COGNITO_FORM_ADMIN_CREATE_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.COGNITO_FORM_ADMIN_DELETE_REQUEST:
      return state.mergeDeep({
        isLoading: true,
      });

    case TYPES.COGNITO_FORM_ADMIN_DELETE_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        lastUpdated: action.receivedAt,
      });

    case TYPES.COGNITO_FORM_ADMIN_DELETE_FAILURE:
      return state.mergeDeep({
        isLoading: false,
      });

    case TYPES.COGNITO_FORM_ADMIN_PATCH_REQUEST:
      return state.mergeDeep({
        isLoading: true,
        form: {
          isSubmitting: true,
          success: null,
          errors: null,
        },
      });

    case TYPES.COGNITO_FORM_ADMIN_PATCH_SUCCESS:
      return state.mergeDeep({
        isLoading: false,
        form: {
          isSubmitting: false,
          success: true,
          errors: null,
        },
        lastUpdated: action.receivedAt,
      });

    case TYPES.COGNITO_FORM_ADMIN_PATCH_FAILURE:
      return state
        .mergeDeep({
          isLoading: false,
          form: {
            isSubmitting: false,
            success: false,
            errors: null,
          },
        })
        .setIn(['form', 'errors'], action.error);

    case TYPES.COGNITO_FORM_ADMIN_FORM_DESTROY:
      return state
        .mergeDeep({
          form: {},
          id: null,
        })
        .set('form', action.form);

    case TYPES.COGNITO_FORM_ADMIN_SHOW_FORM:
      return state.mergeDeep({
        isFormVisible: true,
        id: action.id,
      });

    case TYPES.COGNITO_FORM_ADMIN_HIDE_FORM:
      return state.mergeDeep({
        isFormVisible: false,
      });

    default:
      return state;
  }
}

Logger.log('silly', `CognitoFormsAdmin.reducers loaded.`);
